var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('admin-header',{attrs:{"indexPath":_vm.indexPath}}),_c('div',{staticClass:"content"},[_c('div',{ref:"main",staticClass:"main"},[(_vm.isMainRouterAlive)?_c('router-view',[_c('app-main')],1):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }